<template>
  <div class="block-wrapper">
    <!-- 爆款广告 -->
    <a class="bkadv" v-if="basketJrhdList.advList && basketJrhdList.advList.length>0" :href="basketJrhdList.advList[0].url || ''" target="_blank">
      <img :src="basketJrhdList.advList[0].atturl || ''" />
    </a>
    <!--菜篮子-->
    <block v-if="pcZyjjgwGoodsAdv.advList && pcZyjjgwGoodsAdv.advList.length > 0" :data="pcZyjjgwGoodsAdv" :url="pcZyjjgwGoodsAdv.advList[0].url || ''"></block>

    <!--特价专区-->
    <block v-if="pcXfqfGoodsAdv.advList && pcXfqfGoodsAdv.advList.length > 0" :data="pcXfqfGoodsAdv" :url="pcXfqfGoodsAdv.advList[0].url || ''"></block>

    <!--拼团-->
    <block v-if="pcZyztcpfhGoodsAdv.advList && pcZyztcpfhGoodsAdv.advList.length > 0" :data="pcZyztcpfhGoodsAdv" :url="pcZyztcpfhGoodsAdv.advList[0].url || ''"></block>

    <!--一村一品-->
    <block v-if="pcZyypGoodsAdv.advList && pcZyypGoodsAdv.advList.length > 0" :data="pcZyypGoodsAdv" :url="pcZyypGoodsAdv.advList[0].url || ''"></block>

    <!--供应链专区-->
    <block v-if="pcHmdjkGoodsAdv.advList && pcHmdjkGoodsAdv.advList.length > 0" :data="pcHmdjkGoodsAdv" :url="pcHmdjkGoodsAdv.advList[0].url || ''"></block>

    <!--消费全返专区-->
    <!-- :url="pcZlyyGoodsAdv.advList[0].url" -->
    <block v-if="pcZlyyGoodsAdv.advList && pcZlyyGoodsAdv.advList.length > 0" :data="pcZlyyGoodsAdv" :url="pcZlyyGoodsAdv.advList[0].url || ''"></block>
  </div>
</template>

<script>
import block from './block'

export default {
  props: [
    'pcXfqfGoodsAdv',
    'pcZyypGoodsAdv',
    'pcHmdjkGoodsAdv',
    'pcZlyyGoodsAdv',
    'pcZyztcpfhGoodsAdv',
    'pcZyjjgwGoodsAdv',
    'basketJrhdList'
  ],
  components: {
    block,
  },
  created () {
    console.log(this.pcZyjjgwGoodsAdv);
    console.log(this.pcZyypGoodsAdv);
    console.log(this.pcHmdjkGoodsAdv);
    console.log(this.pcZlyyGoodsAdv);
    console.log(this.pcZyztcpfhGoodsAdv);
    console.log(this.pcZyjjgwGoodsAdv);
    console.log(this.basketJrhdList);
  }
}
</script>

<style scoped lang="less">
.block-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 20px;
}
.bkadv {
  display: block;
  width: 100%;
  height: 346px;
  cursor: pointer;
}
.bkadv img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// index.vue?f25376ae